<template>
  <div class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Permissions" active>
        <h3>Permissions</h3>
        <permission-table :permissions="work_group.role.permissions" />
      </b-tab>
      <b-tab title="Staff">
        <h3>Staff</h3>
        <staff-server-table :show_columns="['last_name', 'email', 'work_groups.name']" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import PermissionTable from "@/components/permission/PermissionTable";
import StaffServerTable from "@/components/lab/staff/StaffServerTable";

export default {
  name: "WorkGroupDetailCardstack",
  components: {
    PermissionTable,
    StaffServerTable
  },
  props: {
    work_group: {
      type: Object,
      default: () => null
    }
  }
}
</script>